import api from '@/api';
import { AxiosResponse } from 'axios';
import {
  fullReportResponseOptions,
  parseReportResponse,
} from '@/utils/functions/reportResponse';
import { API_BASE_URL } from '..';
import {
  CancelInvoiceRequest,
  InvoiceConsultRequest,
  InvoiceFileRequest,
  InvoiceMailRequest,
  InvoiceMirrorRequest,
  InvoiceTransmitRequest,
  invoiceTypeUrl,
} from './Invoice.types';

const CONTROLLER_URL = `${API_BASE_URL}/transmission-hub/invoices`;

export async function CancelInvoice(params: CancelInvoiceRequest) {
  const { invoiceId, justification, type } = params;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/${invoiceTypeUrl[type]}/cancel`,
    { justification },
    null,
  )) as unknown;

  return result;
}

export async function ConsultInvoice(params: InvoiceConsultRequest) {
  const query = new URLSearchParams({
    duplicateKey: params.duplicateKey ?? '',
  });

  const result = (await api.post(
    `${CONTROLLER_URL}/${params.invoiceId}/${
      invoiceTypeUrl[params.type]
    }/consult?${query}`,
    {},
    null,
  )) as unknown;

  return result as string;
}

export async function TransmitInvoice(params: InvoiceTransmitRequest) {
  const query = new URLSearchParams();

  if (params.newNumber) {
    query.append('newNumber', String(params.newNumber));
  }

  const result = (await api.post(
    `${CONTROLLER_URL}/${params.invoiceId}/${
      invoiceTypeUrl[params.type]
    }/transmit?${query}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function MirrorInvoicePdf(
  params: InvoiceMirrorRequest,
): Promise<BlobPart> {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/${params.invoiceId}/${
      invoiceTypeUrl[params.type]
    }/invoice-mirror/pdf`,
    null,
    fullReportResponseOptions,
  )) as unknown;

  return parseReportResponse(result as AxiosResponse<ArrayBufferLike>);
}

export async function MirrorInvoiceXml(params: InvoiceMirrorRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${params.invoiceId}/${
      invoiceTypeUrl[params.type]
    }/invoice-mirror/xml`,
    null,
  )) as unknown;

  return result as Blob;
}

export async function invoiceMail(params: InvoiceMailRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${params.invoiceId}/${invoiceTypeUrl[params.type]}/mail`,
    params,
  )) as unknown;

  return result as void;
}

export async function InvoicePdf(params: InvoiceFileRequest): Promise<BlobPart> {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/${params.invoiceId}/${invoiceTypeUrl[params.type]}/pdf`,
    null,
    fullReportResponseOptions,
  )) as unknown;

  return parseReportResponse(result as AxiosResponse<ArrayBufferLike>);
}

export async function InvoiceXml(params: InvoiceFileRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${params.invoiceId}/${invoiceTypeUrl[params.type]}/xml`,
    null,
  )) as unknown;

  return result as Blob;
}
